/**
 * Created by rhett on 2019/4/13.
 */

import React, {Component} from 'react';
import "./TicketPanel.css";

export default class TicketPanel extends Component
{

  static _instance = null;

  constructor(props)
  {
    super(props);
    TicketPanel._instance = this;
    this.state = {isShow: false,actName:"活动名称"};
  }

  static show(actName, qrCode)
  {
    TicketPanel._instance.setState({isShow: true, actName, qrCode});
  }

  static hide()
  {
    TicketPanel._instance.setState({isShow: false});
  }

  componentDidMount()
  {
  }

  render()
  {
    if (!this.state.isShow) return null;
    return (

      <div className="centerContainer">

        <div className="blackModal">
        </div>

        <div className="TicketPanel">

          <img src={require("./h5_icon_close_normal.png")} className="closeBtn" onClick={TicketPanel.hide}/>

          <div className="ticketTitle">爱家活动签到二维码</div>

          <div className="qrCodeContainer">
            <img src={this.state.qrCode} alt="" className="qrCode"/>
          </div>

          <div className="actName">
            {this.state.actName}
          </div>
        </div>
      </div>
    );
  }

}